/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import './open-banking-account-consents-landing.js';
import './open-banking-payment-consents-landing.js';
const template = html`
    <style include="app-styles">
      .fixed-height{
        height: auto;
      }
    </style>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <iron-pages selected="{{selectedLandingPage}}">
      <div>
        <template is="dom-if" if="{{_selectedIronPage(selectedLandingPage, 0)}}" restamp="true">
            <open-banking-account-consents-landing selected-page={{selectedPage}}></open-banking-account-consents-landing>
        </template>
      </div>
      <div>
        <template is="dom-if" if="{{_selectedIronPage(selectedLandingPage, 1)}}" restamp="true">
            <open-banking-payment-consents-landing selected-page={{selectedPage}}></open-banking-payment-consents-landing>
        </template>
      </div>
    </iron-pages>
    `;
Polymer({
  is: 'open-banking-landing',
  _template: template,
  properties: {
    selectedLandingPage: {
      type: String,
      notify: true
    },
    scope: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingScope');
      },
      observer: "_scopeUpdated"
    }
  },
  _scopeUpdated() {
    if (this.scope == "accounts") {
      this.selectedLandingPage = 0;
    }
    else if (this.scope == "payments") {
      this.selectedLandingPage = 1;
    }
  },
  _selectedIronPage(val1, val2) {
    return val1 == val2;
  }
});
